/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIGuestRequestSearchResult } from './APIGuestRequestSearchResult';
import {
    APIGuestRequestSearchResultFromJSON,
    APIGuestRequestSearchResultFromJSONTyped,
    APIGuestRequestSearchResultToJSON,
} from './APIGuestRequestSearchResult';
import type { APIPagination } from './APIPagination';
import {
    APIPaginationFromJSON,
    APIPaginationFromJSONTyped,
    APIPaginationToJSON,
} from './APIPagination';

/**
 * 
 * @export
 * @interface APIGuestRequestSearchResponse
 */
export interface APIGuestRequestSearchResponse {
    /**
     * 
     * @type {number}
     * @memberof APIGuestRequestSearchResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof APIGuestRequestSearchResponse
     */
    maxScore: number | null;
    /**
     * 
     * @type {Array<APIGuestRequestSearchResult>}
     * @memberof APIGuestRequestSearchResponse
     */
    results: Array<APIGuestRequestSearchResult>;
    /**
     * 
     * @type {APIPagination}
     * @memberof APIGuestRequestSearchResponse
     */
    page: APIPagination;
}

/**
 * Check if a given object implements the APIGuestRequestSearchResponse interface.
 */
export function instanceOfAPIGuestRequestSearchResponse(value: object): value is APIGuestRequestSearchResponse {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('maxScore' in value) || value['maxScore'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    return true;
}

export function APIGuestRequestSearchResponseFromJSON(json: any): APIGuestRequestSearchResponse {
    return APIGuestRequestSearchResponseFromJSONTyped(json, false);
}

export function APIGuestRequestSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIGuestRequestSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'maxScore': json['max_score'],
        'results': ((json['results'] as Array<any>).map(APIGuestRequestSearchResultFromJSON)),
        'page': APIPaginationFromJSON(json['page']),
    };
}

export function APIGuestRequestSearchResponseToJSON(value?: APIGuestRequestSearchResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'total': value['total'],
        'max_score': value['maxScore'],
        'results': ((value['results'] as Array<any>).map(APIGuestRequestSearchResultToJSON)),
        'page': APIPaginationToJSON(value['page']),
    };
}

